import { AfterViewInit, Directive, Inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { User } from '../models/user.model';
import { INFO_USER_RESOLVER_TOKEN, UserInfoResolver } from '../user.token';

@Directive({
  standalone: true,
  selector: '[miqRestrictedUserNotHasUserGroup]',
})
export class RestrictedUserNotHasUserGroupDirective implements AfterViewInit {
  @Input() miqRestrictedUserNotHasUserGroup: string[];
  userInfo: User;
  //TODO: May consider with private templateRef: TemplateRef<any> private viewContainer: ViewContainerRef
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    @Inject(INFO_USER_RESOLVER_TOKEN) private userInfoResolver: UserInfoResolver
  ) {
    this.userInfo = this.userInfoResolver.resolve();
  }
  ngAfterViewInit(): void {
    this.updateRemoval();
  }

  updateRemoval(): void {
    if (!this.hasMiqUserGroup()) {
      this.viewContainer.clear();
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  hasMiqUserGroup(): boolean {
    return (
      !Array.isArray(this.miqRestrictedUserNotHasUserGroup) ||
      !this.userInfo ||
      !this.userInfo.groups ||
      this.userInfo.groups.some(group => this.miqRestrictedUserNotHasUserGroup.includes(group?.value || ''))
    );
  }
}
